import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"

import { formatDateDataGrid } from "src/utils/format-date"
import { DATE_FORMAT_SHOW } from "src/utils/constants"

import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterEmissaoRendaFixaPremioTable = (props) => {
    const datalakeService = new DatalakeService()

    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({
        count: 0,
        next: null,
        previous: null
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .catch(props.callbackError)
            .finally(() => props.loading(false))
    }


    const updateRow = async (newRow) => {
        const {
            ID,
            RendaFixaCaracteristicasID,
            IDEmissao,
            CETIP,
            VersaoDocumento,
            IDEventoPremio,
            DataReferencia,
            DataPremio,
            ValorPremio,
            TipoPremio,
            IDPremio,
            CalculoPremio,
            CasasPremio
        } = newRow

        const body = {
            RendaFixaCaracteristicasID,
            IDEmissao,
            CETIP,
            VersaoDocumento,
            IDEventoPremio,
            DataReferencia,
            DataPremio,
            ValorPremio,
            TipoPremio,
            IDPremio,
            CalculoPremio,
            CasasPremio
        }

        props.loading(true)

        return datalakeService
            .updateTableEndpoint(props.endpoint, ID, body)
            .catch((err) => {
                props.loading(false)
                throw err
            })
            .finally(() => props.loading(false))
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint, query, limit, offset)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const changePage = async (endpoint) => {
        props.loading(true)

        datalakeService
            .paginate(endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            minWidth: 80,
            disableColumnMenu: true,
            disableFilter: true
        },
        {
            field: 'RendaFixaCaracteristicasID',
            headerName: 'RendaFixaCaracteristicasID',
            minWidth: 220,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'IDEmissao',
            headerName: 'IDEmissao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: false
        },
        {
            field: 'CETIP',
            headerName: 'CETIP',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'VersaoDocumento',
            headerName: 'VersaoDocumento',
            minWidth: 150,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'IDEventoPremio',
            headerName: 'IDEventoPremio',
            minWidth: 180,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            minWidth: 150,
            typeComponent: 'date',
            editable: true,
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'DataPremio',
            headerName: 'DataPremio',
            minWidth: 150,
            typeComponent: 'date',
            editable: true,
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'ValorPremio',
            headerName: 'ValorPremio',
            minWidth: 160,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'TipoPremio',
            headerName: 'TipoPremio',
            minWidth: 180,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'IDPremio',
            headerName: 'IDPremio',
            minWidth: 220,
            typeComponent: 'number',
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'CalculoPremio',
            headerName: 'CalculoPremio',
            minWidth: 220,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'CasasPremio',
            headerName: 'CasasPremio',
            minWidth: 150,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            minWidth: 150,
            disableFilter: true,
            disableColumnMenu: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            minWidth: 150,
            disableFilter: true,
            disableColumnMenu: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            updateRow={updateRow}
            pagination={pagination}
            onChangePage={changePage}
            filterFunction={onFilter}
            customFilter={true}
            useDeleteButton={false}
        />
    )
}

ParameterEmissaoRendaFixaPremioTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterEmissaoRendaFixaPremioTable
